import React, { useState } from "react";

import styles from './wallet.module.css';
import { useNavigate } from 'react-router-dom';
import { HeaderItem, StageHeader, Stages } from 'Components/shared/progress';
import { PinInput} from 'Components/main_components/transfer/reusables';
import { TransactionEnd} from 'Components/main_components/wallet/reusables';
import Hidden from "Components/shared/hidden";
import Back from "Components/main_components/registeration/Back";
import useForm from "hooks/useForm";
import Text from "Components/shared/text";
import { RouteAwareCrumbs } from "Components/shared/breadcrumbs";
import { DepositAmount, FundingInstruction, DepositSummary } from "Components/main_components/wallet/deposit";
import { Destination, WithdrawAmount, WithdrawSummary } from "Components/main_components/wallet/withdraw";
import { useWithdrawFromWallet, withdrawFromWallet } from "services/walletService";


const WalletWithdraw = () => {
    const totalStages = 3;
    const navigate = useNavigate();
    const [stage, setStage] = useState(1);
    const [openModal, setOpenModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const handleNext = () => {
        if (!(stage < totalStages))  return ;
        setStage(stage + 1);
    };
    const handlePrev = () => {
        if (!(stage > 1))  return ;
        setStage(stage - 1);
    };
    const handleComplete = () => {
        setOpenModal(true)
    }
   
    const confirmHandler = async(pin, done) => {
        try{
            const {data, status} = await withdrawFromWallet("ngn",values.amount.replace(/[₦\,]+/g, ''),values.bank,pin);
            console.log(pin.join(""), data, status)
            if(status == "Ok"){
                done?.()
            }
        }catch(err){
            console.error(err)
        }
        
        setConfirmModal(true);
    }
    const onSuccessHandler = () => {
        setConfirmModal(false);
        setOpenModal(false)
        navigate('/wallet/naira');
    }

    //Form Related States
    const initialState ={
        amount: '',
        bank:""
    }
    const submitHandler = (values,errors, setSubmitting, setErrors) => {

    }
    const {handleSubmit, values, errors, isSubmitting, isValid, touched, handleUpdate, setValues} = useForm({initialState, submitHandler});
    const NameMap = {
        "/wallet":"Wallet",
        "/wallet/naira":"Naira Wallet",
        "/wallet/naira/withdraw":"Withdraw"
    }
    return(
        <div className={styles.root}>
            <div className={styles.Header}>
            <Text variant="lg" tag="h1" style={{fontWeight:"700"}}>Withdraw</Text>
            <RouteAwareCrumbs nameMap={NameMap} />
        </div>
            <form onSubmit={handleSubmit} className={`${styles.Deposit}`}>
                    <StageHeader currentStage={stage} totalStages={totalStages} className={styles.StageHeader} 
           left={stage >= 2 ?(
               <Hidden smDown>
                   <Back onClick={handlePrev} />
               </Hidden>
           ):null} >
                        <HeaderItem active={stage === 1} passed={stage > 1}>
                        Amount 
                        </HeaderItem>
                        <HeaderItem active={stage === 2} passed={stage > 2}>
                        Destination Summary
                        </HeaderItem>
                        <HeaderItem active={stage === 3} passed={stage > 3}>
                        Summary
                        </HeaderItem>
                    </StageHeader>
                    <Stages active={stage} values={values} setValues={setValues} errors={errors} touched={touched} handleUpdate={handleUpdate} >
                        <WithdrawAmount onNext={handleNext} onPrevious={() => navigate("../")} />
                        <Destination onNext={handleNext} onPrevious={handlePrev} />
                        <WithdrawSummary onNext={handleComplete} onPrevious={handlePrev} />
                    </Stages>
            </form>
                   {stage >2 && <PinInput onCancel={() => setOpenModal(false)} onConfirm={confirmHandler} openModal={openModal} onClose={() => setOpenModal(false)} />}
                    <TransactionEnd openModal={confirmModal} onClose={() => setConfirmModal(false)} onSuccess={onSuccessHandler} onError={() => {}} 
                    />
        </div>
    )
}

export default WalletWithdraw;
